import { ResourceType } from "@/app/generated/prisma"
import { ResourceCard } from "./resourceCards/resourceCard"
import NoDataSvg from "@/assets/svg/no-data.svg"
import Image from "next/image"

export type Resources = {
   download?: string | null
   image: string
   title: string
   description: string
   slug: string
   contentType?: string | null
   category?: {
      name: string
      category_id?: number
   }
}

export function CategoryPanel({ items, type }: { items: Resources[] | undefined; type: ResourceType }) {
   return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
         {items && items.length ? (
            items?.map((item) => {
               return <ResourceCard item={item} key={item.slug} type={type} />
            })
         ) : (
            <div className="col-span-full flex flex-col items-center justify-center gap-4 py-20">
               <div className="relative size-32">
                  <Image src={NoDataSvg} alt="No data available" />
               </div>
               <p className="font-bold text-black">No Resources Found</p>
            </div>
         )}
      </div>
   )
}
